'use client';

import { ApiKeys, fetcher } from '@insta-club/api';
import { Field, FieldsResponse, StoreType } from '@insta-club/models';
import { BadgeSelectSingle, Select } from '@insta-club/ui';
import { useEffect, useRef, useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import useSWR from 'swr';

function AddPageFormStep2() {
    const form = useFormContext();
    const { setValue } = form;
    const selectedField = useWatch({ control: form.control, name: 'field_id' }) as number | string | undefined;
    const [selectedFieldObj, setSelectedFieldObj] = useState<Field | null>(null);
    const prevSelectedFieldRef = useRef<number | null>(null);

    const { data: fields, isLoading: fieldsLoading } = useSWR<FieldsResponse>(ApiKeys.GET_FIELDS, (url: string) =>
        fetcher(url, 'dashboard', 'GET')
    );

    const [fieldId, setFieldId] = useState<string | null>(null);
    const { data: categories, isLoading: categoryLoading } = useSWR<FieldsResponse>(
        fieldId ? ApiKeys.GET_CATEGORIES(fieldId) : null,
        (url: string) => fetcher(url, 'dashboard', 'GET')
    );

    const {
        data: storeTypes
        // isLoading: storeTypesLoading
    } = useSWR<StoreType[]>(ApiKeys.GET_STORE_TYPES, (url: string) => fetcher(url, 'dashboard', 'GET'));

    useEffect(() => {
        if (!fields?.data) return;

        const sel = typeof selectedField === 'string' ? Number(selectedField) : selectedField;
        const obj = fields.data.find((f) => f.id === sel) ?? null;

        if (prevSelectedFieldRef?.current === null && sel !== undefined && sel !== null) {
            setSelectedFieldObj(obj);
            setValue('is_store', Number(obj?.is_store) === 1);
            setFieldId(sel ? sel.toString() : null);
            prevSelectedFieldRef.current = sel ?? null;
            return;
        }

        if (sel !== prevSelectedFieldRef.current) {
            setSelectedFieldObj(obj);
            setValue('category_id', '');
            setValue('store_type', '');
            setValue('is_store', Number(obj?.is_store) === 1);
            setFieldId(sel ? sel.toString() : null);
            prevSelectedFieldRef.current = sel ?? null;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedField, fields?.data]);

    const fieldOptions =
        fields?.data.map((field: Field) => ({
            label: field.name,
            value: field.id
        })) ?? [];

    const categoryOptions =
        categories?.data.map((cat: Field) => ({
            label: cat.name,
            value: cat.id
        })) ?? [];

    const storeTypeOptions =
        storeTypes?.map((type: StoreType) => ({
            label: type.name,
            value: type.type
        })) ?? [];

    const isStoreField = Number(selectedFieldObj?.is_store) === 1;

    return (
        <div className='space-y-5'>
            {/* <Select name='field_id' label='حوزه کاری' options={fieldOptions} isSearchable isLoading={fieldsLoading} /> */}

            <BadgeSelectSingle
                name='field_id'
                label='حوزه کاری'
                options={fieldOptions}
                isLoading={fieldsLoading}
                isSearchable
            />

            {/* <Select
                isSearchable
                name='category_id'
                label='دسته‌بندی'
                options={categoryOptions}
                disabled={!selectedField}
                isLoading={categoryLoading}
            /> */}
            {selectedField && (
                <BadgeSelectSingle
                    name='category_id'
                    label='دسته‌بندی'
                    options={categoryOptions}
                    disabled={!selectedField}
                    isLoading={categoryLoading}
                    isSearchable
                />
            )}

            {/* {isStoreField && <Select name='store_type' label='تعداد تنوع محصولات' options={storeTypeOptions} />} */}
            {isStoreField && <Select name='store_type' label='تعداد تنوع محصولات' options={storeTypeOptions} />}
        </div>
    );
}

export default AddPageFormStep2;

